<div class="text-card-foreground h-full overflow-hidden flex flex-col">
  <!-- rounded-lg border bg-card shadow-xs -->
  <div class="h-fit flex flex-row items-center justify-between space-y-1.5 p-6">
    <h3 class="text-2xl font-semibold leading-none tracking-tight">
      Carrito de Compras
    </h3>
  </div>

  <div
    class="grow flex flex-row items-start justify-between p-6 pt-0 overflow-hidden gap-4"
  >
    <div class="w-full h-full overflow-hidden flex flex-col">
      <div class="h-fit w-full flex flex-row gap-1">
        <ng-select
          [items]="products"
          [(ngModel)]="productToAdd"
          bindLabel="name"
          placeholder="Producto"
          [multiple]="false"
          [searchable]="true"
          [closeOnSelect]="true"
          [clearable]="false"
          (close)="addElement()"
          class="w-full"
        ></ng-select>
        <!-- bindValue="id" -->
        <!-- [(ngModel)]="product_id" -->
        <!-- (search)="searchProduct($event)" -->
      </div>

      <div
        class="mt-2 grow rounded-lg border bg-card h-full w-full flex flex-col items-start gap-2 overflow-x-auto overflow-y-auto scrollbar-thin scrollbar-thumb-slate-500 scrollbar-track-slate-200"
      >
        @for(cartItem of cartItems; track cartItem.id; let idx = $index) {
        <app-shopping-item
          [inputShoppingItem]="cartItem"
          [shoppingCart]="cartId"
          class="w-full"
          (itemIsUpdated)="updateShoppingItem($event)"
          (itemIsDeleted)="deleteShoppingItem($event)"
        ></app-shopping-item>
        }
      </div>
    </div>

    <div
      class="w-80 shink-0 h-full rounded-lg border bg-card flex flex-col p-4"
    >
      <div class="flex flex-row items-center justify-between">
        <h2 class="text-lg font-semibold">Resumen de Compra</h2>

        <!-- <button
          class="text-muted-foreground hover:text-foreground"
          type="button"
        >
          <ng-icon name="featherEdit" class="w-5 h-5" />
        </button> -->
        <!-- (click)="updateCategory(category)" -->
      </div>

      <div class="flex flex-row justify-between mt-4">
        <span>Productos ({{ productCount }})</span>

        <!-- <input type="text"> -->
        <span class="font-semibold">{{ productTotal | currency }}</span>
      </div>
      <!-- <hr> -->

      <div class="flex flex-row justify-between mt-4">
        <span>Descuentos</span>
        <span class="font-semibold text-red-600"
          >-{{ discount | currency }}</span
        >
      </div>

      <div class="flex flex-row justify-between mt-4">
        <span>Subtotal</span>
        <span class="font-semibold">{{ subtotal | currency }}</span>
      </div>

      <div class="flex flex-row justify-between mt-4">
        <span>Flete</span>
        <span>{{ freight | currency }}</span>
      </div>

      <div class="flex flex-row justify-between mt-4">
        <span>Envío</span>
        <span>{{ shipping | currency }}</span>
      </div>

      <hr class="mt-2 border-2" />

      <div class="flex flex-row justify-between mt-4">
        <span>Total</span>
        <span class="font-black">{{ total | currency }}</span>
      </div>

      <button type="button" class="mt-6 primary normal" (click)="createSale()">
        Finalizar Compra
      </button>

      <div class="flex flex-row justify-between mt-4">
        @if (confirmationMessage) {
        <span class="mt-2 text-green-700 text-sm">{{
          confirmationMessage
        }}</span>
        }
      </div>
    </div>
  </div>
</div>
